import { withInstallFunction } from '@jdesign-vue/utils'

import Message from './src/method'

export const JdMessage = withInstallFunction(Message, '$message')
export default JdMessage

export * from './src/message'
